import React from 'react';
import CalendarImports from 'pages/CalendarImports';

const SystemCalendarImports = (props) => <CalendarImports {...props} system />;

export default SystemCalendarImports;
